import { useCallback, useEffect } from 'react';

import PinReminderModal from '@/components/common/PinReminderModal';
import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import { PIN_REMINDER_DELAY_MS } from '@/constants';
import useLocalSettings from '@/stores/useLocalSettings';

import useAuth from './useAuth';

export default function usePinReminder() {
  const { hasDismissedPinReminder, isLikelyPinned } = useLocalSettings();

  const { me } = useAuth();

  const onboardingCompletedAt =
    me?.metadata?.outlookSidebarOnboardingCompletedAt;

  const { showModal } = useModal();

  const showPinReminder = useCallback(
    () => showModal(PinReminderModal),
    [showModal],
  );

  useEffect(() => {
    if (hasDismissedPinReminder || isLikelyPinned || !onboardingCompletedAt)
      return;

    const timeout = setTimeout(showPinReminder, PIN_REMINDER_DELAY_MS);

    return () => clearTimeout(timeout);
  }, [
    hasDismissedPinReminder,
    isLikelyPinned,
    onboardingCompletedAt,
    showPinReminder,
  ]);
}
